import React, { Component, Fragment } from 'react';
import propTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

import AddNewComponent from 'app/AddNewComponent/components/AddNewComponent';
import ComponentSearch from 'app/ComponentSearch/container';
import SearchTab from 'app/Explorer/components/SearchTab';
import { PrimaryButton, ClearButton } from 'ui/Components';

import ComponentPositionInput from './ComponentPositionInput';

/**
 * Add Components to a Page via Editor Pane
 */
export default class AddComponents extends Component {
  static propTypes = {
    addFilter: propTypes.func.isRequired,
    addNewComponentToPage: propTypes.func.isRequired,
    clearSearch: propTypes.func.isRequired,
    componentsList: propTypes.array,
    isReadonly: propTypes.bool,
    pageType: propTypes.string.isRequired,
    pageTemplateName: propTypes.string.isRequired,
    renderingEnvName: propTypes.string,
    pageComponents: propTypes.arrayOf(propTypes.number)
  };

  static defaultProps = {
    componentsList: [],
    pageComponents: [],
    isReadonly: true,
    renderingEnvName: ''
  };

  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false
    };

    this.handleInsertExisting = this.handleInsertExisting.bind(this);
    this.toggleAddExistingComponentsModal = this.toggleAddExistingComponentsModal.bind(this);
  }

  /**
   * handle inserting an existing component to a page
   */
  handleInsertExisting() {
    this.toggleAddExistingComponentsModal();
  }

  /**
   * toggle the search modal state between open and close
   */
  toggleAddExistingComponentsModal() {
    // including this eslint-disable below because using the previous state (ps) param with setState did not work here.
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ isModalOpen: !this.state.isModalOpen }, () => this.props.clearSearch());
  }

  /**
   * Render inserting existing component
   * @returns {React.Component} jsx
   */
  renderInsertExistingComponent() {
    const { componentsList, addFilter, pageComponents } = this.props;
    const { isModalOpen } = this.state;
    return (
      <Modal isOpen={isModalOpen} toggle={this.toggleAddExistingComponentsModal}>
        <ModalHeader>Search for a Component</ModalHeader>
        <ModalBody data-test-id="attach-child-modal-body">
          <ComponentSearch
            hideLists={false}
            onFinish={this.toggleAddExistingComponentsModal}
          />
          {pageComponents.length && (
            <ComponentPositionInput maxLength={pageComponents.length} />
          )}
          <SearchTab
            addFilter={addFilter}
            componentsList={componentsList}
            hidePageSelection
            onFinish={this.toggleAddExistingComponentsModal}
            openForEditing={false}
          />
        </ModalBody>
        <ModalFooter>
          <ClearButton
            onClick={this.toggleAddExistingComponentsModal}
            data-test-id="addComponents-cancelButton"
          >
            Cancel
          </ClearButton>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const {
      addNewComponentToPage,
      componentsList,
      isReadonly,
      pageType,
      pageTemplateName,
      renderingEnvName,
      pageComponents
    } = this.props;

    return (
      <Fragment>
        <div className="d-flex pb-3">
          <PrimaryButton
            className="mr-2"
            data-test-id="addComponents-insertExisting"
            disabled={isReadonly}
            onClick={this.handleInsertExisting}
          >
            + Insert Existing
          </PrimaryButton>
          <AddNewComponent
            buttonText="+ Add New"
            componentsList={componentsList}
            data-test-id="addComponents-addNew"
            isReadonly={isReadonly}
            newComponentSelected={addNewComponentToPage}
            pageTemplateName={pageTemplateName}
            pageType={pageType}
            renderingEnvName={renderingEnvName}
            pageComponents={pageComponents}
          />
        </div>
        {this.renderInsertExistingComponent()}
      </Fragment>
    );
  }
}
